<template>
    <Loader v-if="isLoading" show class="mt-2" />
    <div v-else class="dashboard-view">
        <Header
            :rightButtonText="$t('form.button.edit')"
            @clickRightButton="onClickEditDashboard"
        >
            <template slot="center">
                <span class="title">{{ dashboard.title }}</span>
            </template>
        </Header>
        <div class="body">
            <Charts
                :showSubjectsResults="showSubjectsResults"
                :showEvaluationsStatus="showEvaluationsStatus"
                :showQuestionnaireResults="showQuestionnaireResults"
                :showEvaluationsStatusBySections="
                    showEvaluationsStatusBySections
                "
            />
        </div>
    </div>
</template>
<script>
import { getDashboard } from '@/views/reports/api'
import { CHART_INFO_TYPES } from '@/views/reports/constants'
import { Loader, Header, Charts } from '@/views/reports/components'
export default {
    components: {
        Header,
        Charts,
        Loader,
    },
    data() {
        return {
            isLoading: false,
            dashboardId: null,
            dashboard: {
                charts: [],
            },
        }
    },
    computed: {
        showSubjectsResults() {
            return this.hasChart(CHART_INFO_TYPES.SUBJECTS_RESULTS_BY_NETWORK)
        },
        showEvaluationsStatus() {
            return this.hasChart(CHART_INFO_TYPES.EVALUATIONS_STATUS)
        },
        showQuestionnaireResults() {
            return this.hasChart(CHART_INFO_TYPES.QUESTIONNAIRES_RESULTS)
        },
        showEvaluationsStatusBySections() {
            return this.hasChart(CHART_INFO_TYPES.EVALUATIONS_STATUS_BY_TEAM)
        },
        charts() {
            return this.dashboard.charts.map(c => c.info_type)
        },
    },
    mounted() {
        this.setDashboardId()
        this.getDashboard()
    },
    methods: {
        setDashboardId() {
            this.dashboardId = this.$route.params.id
        },
        async getDashboard() {
            this.isLoading = true
            this.dashboard = await getDashboard(this.dashboardId, {
                with: 'charts',
                filter:
                    'id;title;charts.dashboard_id;charts.format;charts.info_type',
            })
            this.isLoading = false
        },
        onClickEditDashboard() {
            this.$router.push(`/v2/reports/edit/${this.dashboardId}`)
        },
        hasChart(chartType) {
            return this.charts.includes(chartType)
        },
    },
}
</script>
<style lang="scss" scoped>
.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.dashboard-view {
    color: #6e6e6e;
    animation-name: fadeIn;
    animation-duration: 0.4s;

    .title {
        font-weight: 700;
        font-size: 24px;
    }

    .body {
        padding: 20px;
        margin: 36px 28px;
        border-radius: 3px;
        background: #ffffff;
        border: 1px solid #bec0c0;
    }
}
</style>
